export default __webpack_public_path__ + "static/logistics-a98fb0483cc598ee0508888156b8cbec.png";